import { Center, Flex, Grid, GridItem, Spinner } from "@chakra-ui/react";
import PageHeader from "components/layout/PageHeader";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiRequest } from "utils/api";
import CompanyBorrowers from "./CompanyBorrowers";
import ExposureLimit from "./ExposureLimit";
import LoansTable from "components/elements/LoansTable";
import WidgetBox from "components/elements/WidgetBox/widget-box";
import { Entities } from "components/entities/entities";
import { Properties } from "components/properties/properties";

function Company() {
    const { id } = useParams();

    const [company, setCompany] = useState<any | null>(null);

    const loadCompany = useCallback(async () => {
        const { companies } = await apiRequest("/supabase/companies/select", {
            id,
        });
        setCompany(companies[0]);
    }, [id]);

    useEffect(() => {
        if (id) {
            loadCompany();
        }
    }, [id, loadCompany]);

    if (!company) {
        return (
            <Center>
                <Spinner />
            </Center>
        );
    }

    return (
        <>
            <PageHeader
                title={company.name}
                breadcrumbs={[
                    {
                        title: "Borrowers",
                        to: "/borrowers",
                    },
                    {
                        title: company.name,
                        to: `/companies/${company.id}`,
                    },
                ]}
            />
            <Grid templateColumns={{ base: "1fr", md: "9fr 3fr" }} gap={4}>
                <GridItem>
                    <Flex flexDirection="column" gap={4}>
                        <Entities companyId={company.id} />
                        <Properties companyId={company.id} />

                        <WidgetBox title="Loans">
                            <LoansTable
                                small
                                borrower_company={company.id}
                                columns={[
                                    "Date",
                                    "Name",
                                    "Type",
                                    "Status",
                                    "Amount",
                                ]}
                            />
                        </WidgetBox>
                    </Flex>
                </GridItem>
                <GridItem>
                    <Flex gap={4} flexDirection="column">
                        <ExposureLimit company={company} />
                        <CompanyBorrowers
                            company={company}
                            title="Contacts"
                            maxHeight="100%"
                        />
                    </Flex>
                </GridItem>
            </Grid>
        </>
    );
}

export default Company;
